// extracted by css-extract-rspack-plugin
export default {"experimentation":"RKB25h5rm8Qry23s","description":"rqwHHR4CUId3viBB","alert":"V9NjVrrIdlw4IBCO"};